import { findRachisError } from '@feathr/rachis';

/** anhinga's code for a delivery address that is not an eligible user on the account. */
export const DELIVERY_EMAIL_NOT_ACCOUNT_USER = 'export.delivery_email_not_account_user';

/**
 * True when the export POST rejected the delivery address because it no longer
 * belongs to an eligible user on the account — e.g. the user was archived or
 * removed after the picker loaded. See anhinga#8529.
 */
export function isDeliveryEmailNotAccountUserError(error: unknown): boolean {
  return (
    findRachisError(error, (entry) => entry.code === DELIVERY_EMAIL_NOT_ACCOUNT_USER) !== undefined
  );
}
